<template>
	<div class="home">
		<header>
            <Header />
        </header>
		<main>
			<!-- banner -->
			<section class="banner">
				<img src="../assets/images/banner.jpg" alt="" />
                <span class="banner-title">智能云算力资源交易平台</span>
                <span class="banner-text">连接全球算力资源，助力企业数字化转型</span>
			</section>
			<!-- tag -->
			<section class="tag_card">
				<div class="container">
					<div class="row">
						<div class="col-6 col-xl-3 ">
							<div class="card-tag-item">
								<div class="item-price">
									<VueCountUp :start-value="0" :end-value="baseData.dealCount" :duration="4" :decimals="0" :delay="1" /><span class="item-unit">单</span>
								</div>
								<div class="item-text">累计成交量</div>
							</div>
						</div>
						<div class="col-6 col-xl-3">
							<div class="card-tag-item">
								<div class="item-price">
									<VueCountUp :start-value="0" :end-value="baseData.entCount" :duration="4" :decimals="0" :delay="1" /><span class="item-unit">所</span>
								</div>
								<div class="item-text">入驻企业数量</div>
							</div>
						</div>
						<div class="col-6 col-xl-3">
							<div class="card-tag-item">
								<div class="item-price">
									<VueCountUp :start-value="0" :end-value="baseData.resourceCount" :duration="4" :decimals="0" :delay="1" /><span class="item-unit">台</span>
								</div>
								<div class="item-text">资源总量</div>
							</div>
						</div>
						<div class="col-6 col-xl-3">
							<div class="card-tag-item">
								<div class="item-price">
									<VueCountUp :start-value="0" :end-value="baseData.powerCount" :duration="4" :decimals="0" :delay="1" /><span class="item-unit">个</span>
								</div>
								<div class="item-text">累计需求数量</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- resources 资源市场 -->
			<section class="resources-card">
				<div class="container">
					<div class="row mb20">
						<div class="card-data-info">
							<h1 style="font-size:1.5rem;">资源市场</h1>
							<div>
								<div class="submit-button" @click="resourcesRelease">发布 资源</div>
								<div class="view-more" @click="$router.push({path:'/resources'})">查看更多 <i class="el-icon-right"></i></div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-xl-3 mb-4 resources-card-item" v-for="(item,index) in resourcesData" :key="index">
							<img :src="item.img" alt="img">
							<div class="resources-data-list">
								<div class="resources-title" :title="item.resourceName">{{ item.resourceName }}</div>
								<div class="resources-tag">
									<span class="tag ">{{ item.model }}</span>
									<span class="tag ">{{ item.networking }}</span>
								</div>
								<div class="resources-info">
									<div class="resources-price">
										<span v-if="item.monthRent != null"> ￥{{ item.monthRent }} 元/月 </span>
										<span v-else-if="item.yearRent != null"> ￥{{ item.yearRent }} 元/年</span>
									</div>
									<div class="resources-sales">
										<span v-if="item.monthRent != null"> 月租</span>
										<span v-else-if="item.yearRent != null">年租 </span>
									</div>
								</div>
								<div class="resources-buy" @click="resourcesBuy(item)">立即 购买</div>
							</div>
						</div>
						<div v-if="resourcesData.length === 0" class="data-empty">
							<el-empty description="暂无数据"></el-empty>
						</div>
					</div>
				</div>
			</section>
			
			<!-- demand 需求市场 -->
			 <section class="demand-card">
				<div class="container">
					<div class="row mb20">
						<div class="card-data-info">
							<h1 style="font-size:1.5rem;">需求市场</h1>
							<div>
								<div class="submit-button" @click="demandRelease">发布需求</div>
								<div class="view-more" @click="$router.push({path:'/demand'})">查看更多 <i class="el-icon-right"></i></div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-xl-6 demand-card-item" v-for="(item,index) in demandMarketData" :key="index" @click="$router.push({path:'/demand'})">
							<div class="demand-item-border mb-4">
								<div class="demand-common-item">
									<div class="demand-title" :title="item.requireTitle">{{ item.requireTitle }}</div>
									<div class="demand-tag">
										<span  class="color1">{{ item.requireLabel }}</span>
									</div>
								</div>
								<div class="demand-desc" :title="item.requireDesc">{{ item.requireDesc }}</div>
								<div class="demand-common-item">
									<div>发布时间 <span>{{ item.insertTime }}</span></div>
									<div>资源预算 <span>{{ item.budget }}</span></div>
								</div>
								<!-- <div class="demand-contact">立即查看 <i class="el-icon-right"></i></div> -->
							</div>
							
							
						</div>
						<div v-if="demandMarketData.length === 0" class="data-empty">
							<el-empty description="暂无数据"></el-empty>
						</div>
					</div>
				</div>
			 </section>
			<!-- news 行业新闻 -->
			<section class="news-card">
				<div class="container">
					<div class="row mb20">
						<div class="card-data-info">
							<h1 style="font-size:1.5rem;">行业新闻</h1>
							<div class="view-more" @click="$router.push({path:'/news'})">查看更多 <i class="el-icon-right"></i></div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-xl-4 mb-4 card-news-item" v-for="(item,index) in newsData" :key="index" @click="routeDetailNews(item.id)">
							<div class="images">
								<img :src="item.bannerImage" alt="img">
							</div>
							<div class="news-box">
								<div class="news-date">{{ item.insertTime }}</div>
								<div class="news-title mt10" :title="item.newsTitle">{{ item.newsTitle }}</div>
								<div class="news-desc mt10" :title="item.newsContent">{{ item.newsContent }}</div>
							</div>
							
						</div>
						<div v-if="newsData.length === 0" class="data-empty">
							<el-empty description="暂无数据"></el-empty>
						</div>
					</div>
				</div>
			</section>
			<!-- notice 通知公告 -->
			<section class="notice-card">
				<div class="container">
					<div class="row mb20">
						<div class="card-data-info">
							<h1 style="font-size:1.5rem;">通知公告</h1>
							<div class="view-more" @click="$router.push({path:'/notice'})">查看更多 <i class="el-icon-right"></i></div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-xl-12 mb-4 notice-cards" v-for="(item,index) in noticeData" :key="index" @click="routeDetailNotice(item.id)">
							<div class="cards-notice-item">
								<div class="notice-text">
									<div class="notice-label">
										<span v-if="item.noticeCate=='入驻企业'" class="color1">入驻企业</span>
										<span v-if="item.noticeCate=='成交信息'" class="color2">成交信息</span>
										<span v-if="item.noticeCate=='系统通知'" class="color3">系统通知</span>
									</div>
									<div class="notice-date">{{item.insertTime}}</div>
								</div>
								<div class="notice-title">{{ item.noticeTitle }}</div>
								<div class="notice-desc">{{ item.noticeContent }}</div>
							</div>
						</div>
						<div v-if="noticeData.length === 0" class="data-empty">
							<el-empty description="暂无数据"></el-empty>
						</div>
					</div>
				</div>
			</section>
		</main>
		<submit-demand ref="submitDemand"></submit-demand>
		<submit-resources ref="submitResources"></submit-resources>
		<purchase-page ref="purchasePage" :isVisibleResPay.sync="isVisibleResPay" :buyData="buyData"></purchase-page>
	</div>
</template>

<script>
import Header from '../components/header.vue';
import SubmitDemand from './submitDemand.vue';
import SubmitResources from './submitResources.vue';
import PurchasePage from './purchasePage.vue';
import { 
	baseCount,
	newsList,
	noticeList,
	resourceMarketList,
	demandMarketList,
} from '@/api/index';
import { Toast } from 'vant';
export default {
  	name: 'Home',
	components: {
		Header,
		SubmitDemand,
		SubmitResources,
		PurchasePage
	},
	data() {
		return {
			baseData:{},//数据展示 数值
			newsData:[],
			noticeData:[],
			resourcesData:[],
			demandMarketData:[],
			isVisibleResPay:false,
			buyData:{},
		};
		
		
	},
	mounted() {
		this.getBaseCount();
		this.getNewsList();
		this.getNoticeList();
		this.getResourcesList();
		this.getDemandMarketList();
	},
	methods:{
		//获取展示数据
		async getBaseCount(){
			const data = await baseCount();
			this.baseData = data.data;
		},
		// 发布资源
		resourcesRelease(){
			//获取当前屏幕宽度，通过宽度判断是否为pc端或移动端
			let screenWidth = window.innerWidth;
			// 1.判断用户是否登录
			let token = sessionStorage.getItem('cloud_login_token');
			if(!token){
				if(screenWidth > 1000){
					//打开pc端弹窗
					this.$store.commit('SET_LOGIN_DIALOG_STATE', true);
				}else {
					//跳转移动端登录页面
					this.$router.push({ path: '/mobileLogin' });
				}
				return;
			}
			// 2.判断用户是否为资源用户
			let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
			if(cloud_login_user_role != 3){
				if(screenWidth > 1000){
					this.$message.closeAll();
					this.$message.error('您不是资源用户,不能发布资源');
				}else {
					Toast.fail('您不是资源用户,不能发布资源');
				}
				return;
			}
			// 3.打开发布资源弹窗
			if(screenWidth > 1000){
				this.$store.commit('SET_RESOURCES_DIALOG_STATE', true);
			}else {
				this.$router.push({ path: '/mobileResource' });
			}
		},
		// 资源市场-列表
		async getResourcesList(){
			let param = {
				pageNum:1,
				pageSize:4,
				model:"", //型号
				networking:'',//组网
				rentType:'',//1 月租  2 年租  
				resourceName:"",//资源名称
			}
			const data = await resourceMarketList(param);
			if(!data){
				return;
			}
			let imagesList = [
				require('../assets/images/r1.jpg'),
				require('../assets/images/r2.jpg'),
				require('../assets/images/r3.jpg'),
				require('../assets/images/r4.jpg'),
			]
			// 给资源数据添加图片
			data.data.records.forEach((item,index) => {
				item.img = imagesList[index];
			})
			this.resourcesData = data.data.records;
		},
		// 购买资源
		resourcesBuy(row){

			//获取当前屏幕宽度，通过宽度判断是否为pc端或移动端
			let screenWidth = window.innerWidth;
			// 1.判断用户是否登录
			let token = sessionStorage.getItem('cloud_login_token');
			if(!token){
				if(screenWidth > 1000){
					//打开pc端弹窗
					this.$store.commit('SET_LOGIN_DIALOG_STATE', true);
				}else {
					//跳转移动端登录页面
					this.$router.push({ path: '/mobileLogin' });
				}
				return;
			}
			// 2.判断用户是否为需求用户
			let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
			if(cloud_login_user_role == 3 || cloud_login_user_role == 4){
				
				
				if(screenWidth > 1000){
					this.$message.closeAll();
					this.$message.error('您不是需求用户,不能购买资源');
				}else {
					Toast.fail('您不是需求用户,不能购买资源');
				}
				return;
			}
			if(screenWidth > 1000){
				this.buyData = row;
				this.isVisibleResPay = true;
			}else {
				sessionStorage.setItem('buyData',JSON.stringify(row));
				this.$router.push({path:'/mobilePay'})
			}
			// 
			
			
		},
		// 发布需求
		demandRelease() {
			// 获取当前屏幕宽度
			let screenWidth = window.innerWidth;
			
			// 获取token
			let token = sessionStorage.getItem('cloud_login_token');
			
			// 判断是否没有token
			if (!token) {
				// 没有token且屏幕宽度大于1000，打开pc端登录弹窗
				if (screenWidth > 1000) {
					this.$store.commit('SET_LOGIN_DIALOG_STATE', true);
				} else {
					// 否则跳转移动端登录页面
					this.$router.push({ path: '/mobileLogin' });
				}
				return; // 结束函数执行
			}

			// 获取用户角色
			let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');

			// 判断用户是否为个人用户或公司用户
			if (cloud_login_user_role !== '1' && cloud_login_user_role !== '2') {
				if (screenWidth > 1000) {
					this.$message.error('您不是个人用户或公司用户,不能发布需求');
				} else {
					Toast.fail('当前用户不能发布需求,请更换账号');
				}
				return; // 结束函数执行
			}

			// 打开发布需求弹窗，区分pc端和移动端
			if (screenWidth > 1000) {
				// PC端弹窗
				this.$store.commit('SET_DEMAND_DIALOG_STATE', true);
			} else {
				// 移动端页面
				this.$router.push({ path: '/mobileDemand' });
			}
		},
		//需求市场- 列表
		async getDemandMarketList(){
			let param = {
				pageNum:1,
				pageSize:4,
				requireTitle:"",//需求标题
				startDate:"",//开始时间
				endDate :"",//结束时间
			}
			const data = await demandMarketList(param);
			this.demandMarketData = data.data.records;
		},
		//获取新闻列表
		async getNewsList(){
			//获取列表三条数据，参数传空
			let param = {
				pageNum:1,
				pageSize:3,
				// newsCate:'',
				// newsResource:'',
				// timeType:'',
				// newsTitle:''
			}
			const data = await newsList(param);
			this.newsData = data.data.records;
		},
		// 跳转新闻详情
		routeDetailNews(id){
            sessionStorage.setItem('newsId',id);
            this.$router.push({path:'/newsDetail'})
        },
		//获取公告列表
		async getNoticeList(){
			let param = {
				pageNum:1,
				pageSize:3,
			}
			const data = await noticeList(param);
			this.noticeData = data.data.records;
		},
		// 跳转公告详情
		routeDetailNotice(id){
            sessionStorage.setItem('noticeId',id);
            this.$router.push({path:'/noticeDetail'})
        },
	}
}
</script>
<style lang="scss" scoped>
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}
.banner {
    position: relative;
    cursor:default;
	.banner-title {
        position: absolute;
        top: 30%;
        left: 15%;
        font-size:2.2rem;
        letter-spacing: 0.2rem;
        font-weight: 600;
        color: #fff;
        z-index: 99;
	}
	.banner-text {
        position: absolute;
        top: 50%;
        left: 15%;
        font-size:1rem;
        letter-spacing: 0.2rem;
        color: rgba(255, 255, 255, 0.9);
        z-index: 99;
    }
}
.banner img {
    width: 100%;
    height: 20rem;
}

.tag_card{
	width: 100%;
	height:auto;
	padding:40px 0 40px;
	background-color: #fff;
	cursor:default;
	.card-tag-item{
		// width: 100%;
		// height: 100%;
		padding: 20px 20px;
		border-radius: 0.2rem;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
		transition: transform 0.2s ease-in-out;
		.item-price{
			font-size: 1.8rem;
			font-weight: 600;
			color: #106eea;
			.item-unit{
				font-size: 0.8rem;
				margin-left:4px;
			}
		}
		.item-text{
			font-size: 0.8rem;
			margin-top:10px;
			color: #666;
		}
	}
	.card-tag-item:hover{
		transform: translateY(-5px);
	}
}
.resources-card{
	width: 100%;
	height:auto;
	padding:40px 0 40px;
	background-color: #f9fafb;
	cursor:default;
	.resources-card-item{
		margin-bottom:20px;
		// padding:20px 20px;
		transition: transform 0.2s ease-in-out;
		img{
			width:100%;
			height:220px;
			border-radius: 10px 10px 0 0;
		}
		.resources-data-list{
			width:100%;
			height:auto;
			min-height:200px;
			box-sizing: border-box;
			padding:20px 20px;
			border-radius:0 0 10px 10px;
			background-color: #fff;
			position:relative;
			.resources-title{
				color:#000;
				font-size:1rem;
				font-weight:600;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				position:relative;
			}
			.resources-tag{
				width:100%;
				height:40%;
				margin-top:0.5rem;
				position:relative;
				.tag{
					padding:5px 5px;
					font-size:14px;
					color:#0066ff;
					background-color: #dbeafe;
					border-radius:5px;
					margin-right:10px;
				}
			}
			.resources-info{
				line-height:40px;
				margin-top:10px;
				display: flex;
				justify-content: space-between;
				.resources-price{
					color:#0066FF;
					font-size:0.9rem;
					font-weight:600;
					position:relative;
				}
				.resources-sales{
					color:#6b7280;
					font-size:0.8rem;
					position:relative;
				}
			}
			.resources-buy{
				width:100%;
				height:40px;
				text-align:center;
				line-height:40px;
				font-size:15px;
				border-radius:5px;
				color:#fff;
				background-color: #0066FF;
				transition:0.5s;
				cursor:pointer;
				position:relative;
			}
		}
		.resources-data-list::before{content:"";position:absolute;right:0;top:0;height:200px;width:0;background:#1b56a5;-moz-transition:all .6s ease-in-out;-webkit-transition:all .6s ease-in-out;-o-transition:all .6s ease-in-out;-ms-transition:all .6s ease-in-out;transition:all .6s ease-in-out}
	}

	.resources-card-item:hover{
		transform: translateY(-10px);
	}
	.resources-card-item:hover .resources-data-list::before{
		left:0;width:100%
	}
	.resources-card-item:hover .resources-title{
		color:#fff;
	}
	.resources-card-item:hover .resources-tag{
		.tag{
			background-color:#fff;
			// color:#0066FF;
		}
	}
	.resources-card-item:hover .resources-info{
		.resources-price{
			color:#fff;
		}
		.resources-sales{
			color:#fff;
		}
	}
	.resources-card-item:hover .resources-buy{
		background-color:#fff;
		color:#0066FF;
	}
}
.demand-card{
	height:auto;
	padding:40px 0 40px;
	background-color: #fff;
	cursor:default;
	.demand-card-item{
		height:auto;
		
		position:relative;
		background-color: #fff;
		.demand-item-border{
			// min-height:180px;
			box-sizing:border-box;
			padding:20px 20px;
			border:1px solid #E5E7EB;
			border-radius:10px;
			.demand-common-item{
				width:100%;
				height:auto;
				font-size:16px;
				color:#6b7280;
				display:flex;
				justify-content: space-between;
				.demand-title{
					width:80%;
					color:#000;
					font-size:20px;
					font-weight: 600;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.demand-tag{
					width:20%;
					color:#000;
					font-size:1rem;
					font-weight:600;
					display: flex;
					justify-content: flex-end;
					span{
						display:inline-block;
						margin-left:10px;
						width:auto;
						// height:30px;
						padding:2px 8px;
						// text-align:center;
						line-height:1.5rem;
						font-size:14px;
						font-weight:normal;
						font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
						
					}
				}
			}
			.demand-desc{
				height:50px;
				color:#4b5563;
				font-size:16px;
				margin:15px 0;
				display: -webkit-box;
				-webkit-line-clamp: 2; 
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.demand-contact{
				font-size: 18px;
				color:#0066FF;
				margin-top:10px;
				cursor:pointer;
			}
		}
		.demand-item-border:hover{
			cursor:pointer;
			//border:2px solid #144ea1;
			box-shadow: 2px 0 10px rgba(0,0,0,0.1);
		}
	}
}
.news-card{
	width: 100%;
	height:auto;
	padding:50px 0 40px;
	background-color: #f9fafb;
	cursor:default;
	.card-news-item{
		// width:30%;
		height:auto;
		.images{
			width:100%;
			max-height:220px;
			overflow: hidden;
			position: relative;
			img{
				width:100%;
				height:100%;
				border-radius: 10px 10px 0 0;
				transition: transform 0.5s linear;
			}
		}
		// .images:hover img{transform: scale(1.05)}
		.news-box{
			width:100%;
			// height:180px;
			box-sizing: border-box;
			padding:20px 20px;
			border-radius:0 0 10px 10px;
			background-color: #fff;
			.news-date{
				color:#6b7280;
				font-size:0.8rem;
			}
			.news-title{
				width:100%;
				// height:50px;
				color:#000;
				font-size:1rem;
				font-weight:600;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}
			.news-desc{
				color:#4b5563;
				font-size:0.8rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}
		
	}
	.card-news-item:hover{
		.images img{transform: scale(1.1)}
		.news-box{
			// color:#144ea1;
			transition:0.3s;
			background-color: #f3f4f6;
			cursor:pointer;
			.news-date{
				color:#144ea1;
			}
			.news-title{
				color:#144ea1;
			}
			.news-desc{
				color:#144ea1;
			}

		}
	}
}
.notice-card{
	width:100%;
	height:auto;
	padding:50px 0 40px;
	background-color: #fff;
	cursor:default;
	.notice-cards{
		width:100%;
		height:100%;
		margin-bottom:15px;
		box-sizing:border-box;
		padding:20px 20px;
		border-radius: 10px;
		font-size:0.8rem;
		box-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
		.cards-notice-item{
			
			.notice-text{
				display: flex;
				margin-bottom: 10px;
				.notice-label span{
					display:inline-block;
					margin-right:10px;
					width:80px;
					height:30px;
					text-align:center;
					line-height:30px;
					font-size:13px;
					font-weight:normal;
					font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
						
				}
				.notice-date{
					color:#666;
					font-size:0.8rem;
					line-height:30px;
					margin-right: 10px;
				}
			}
			.notice-title{
				color:#333;
				font-size:1rem;
				font-weight:600;
				display: -webkit-box;
				-webkit-line-clamp: 1; 
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.notice-title:hover{
				color:#0066ff;
				cursor:pointer;
			}
			.notice-desc{
				color:#4b5563;
				margin-top:10px;
				font-size:0.8rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}
		}
	}
}

</style>

<style  scoped>
.data-empty{
	width:100%;
	height:100%;
	text-align: center;
}
.card-data-info{
	width:100%;
	height:40px;
	line-height:40px;
	display: flex;
	justify-content: space-between;
}
.card-data-info .view-more{
	display:inline-block;
	color:#0066ff;
	font-size:0.8rem;
	cursor:pointer;
}
.card-data-info .submit-button{
	display:inline-block;
	width:100px;
	height:34px;
	margin-right:10px;
	text-align: center;
	line-height:34px;
	font-size:15px;
	color:#fff;
	border-radius:5px;
	background-color: #0066FF;
	transition:0.3s;
	cursor:pointer;
}
.card-data-info .submit-button:hover{
	background-color:#409EFF;
}
.color1{
	border-radius:20px;
	color:#0066ff;
	background-color: #dbeafe;
}
.color2{
	border-radius:20px;
	color:#ca8a04;
	background-color: #fef9c3;
}
.color3{
	border-radius:20px;
	color:#16a34a;
	background-color: #dcfce7;
}
</style>